export const ACCESS_TOKEN_COOKIE_NAME = "front_access_token";

export const TECHNOLOGY_JUNIOR_ID = +process.env.VUE_APP_TECHNOLOGY_JUNIOR_ID;
export const TECHNOLOGY_MIDDLE_ID = +process.env.VUE_APP_TECHNOLOGY_MIDDLE_ID;
export const TECHNOLOGY_SENIOR_ID = +process.env.VUE_APP_TECHNOLOGY_SENIOR_ID;
export const TECHNOLOGY_INTERAGE_ID =
  +process.env.VUE_APP_TECHNOLOGY_INTERAGE_ID;
export const TECHNOLOGY_TEAM = +process.env.VUE_APP_TECHNOLOGY_TEAM;
export const CIRCLE_DEVELOPMENT_ENVIRONMENT =
  +process.env.VUE_APP_CIRCLE_DEVELOPMENT_ENVIRONMENT;

export const CONTEST_EVENTS = Object.freeze({
  TECHNOLOGY_JUNIOR_ID,
  TECHNOLOGY_MIDDLE_ID,
  TECHNOLOGY_SENIOR_ID,
  TECHNOLOGY_INTERAGE_ID,
  TECHNOLOGY_TEAM,
  CIRCLE_DEVELOPMENT_ENVIRONMENT,
});

export const REQUEST_STATUS_REJECTED = -2; // Отклонена пользователем
export const REQUEST_STATUS_AWAIT = 0; // Ожидает модерации
export const REQUEST_STATUS_CANCELED = -1; // Отклонена модератором
export const REQUEST_STATUS_CONFIRMED = 1; // Согласована модератором

export const PLATFORM_COVER_WIDTH = 720;
export const PLATFORM_COVER_HEIGHT = 348;
export const MAX_LOGO_SIZE = 3000;

export const ORGANIZATION_FIELD_NAME = "Организация";
export const PLATFORM_FIELD_NAME = "Площадка";
